export default __webpack_public_path__ + "static/media/vid-chat.4f6b1c15.PNG";